import { Injectable } from '@angular/core';
import { FullStory } from '@fullstory/browser';

import { environment } from '../../../../environments/environment';
import { User } from '../../types';

export const FULLSTORY_ACCOUNT_SWITCHED_EVENT = 'Account Switched';

// TODO: remove after the QA tests and before merging. QA and staging builds have production: false.
const FULLSTORY_EXTRA_ENVIRONMENTS: readonly string[] = ['qa', 'staging'];

export function isFullstoryEnabled(): boolean {
  return (
    environment.production ||
    FULLSTORY_EXTRA_ENVIRONMENTS.includes(environment.ENV)
  );
}

export interface FullstoryAccount {
  id: number;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class FullstoryService {
  public identify(user: Pick<User, 'id' | 'usrName' | 'eml'>): void {
    if (!isFullstoryEnabled()) {
      return;
    }
    FullStory('setIdentity', {
      uid: user.id.toString(),
      properties: {
        displayName: user.usrName,
        email: user.eml,
      },
    });
  }

  /**
   * Releases the identified user and starts a new anonymous session, so the
   * next login in the same browser is not attributed to the previous user.
   */
  public anonymize(): void {
    if (!isFullstoryEnabled()) {
      return;
    }
    FullStory('setIdentity', { anonymous: true });
  }

  /**
   * An operator impersonating another account stays the FullStory user (a new
   * uid would split the session); the switch is recorded as an event instead.
   */
  public trackAccountSwitched(
    from: FullstoryAccount,
    to: FullstoryAccount
  ): void {
    if (!isFullstoryEnabled() || from.id === to.id) {
      return;
    }
    FullStory('trackEvent', {
      name: FULLSTORY_ACCOUNT_SWITCHED_EVENT,
      properties: {
        from_account_id: from.id,
        from_account_name: from.name,
        to_account_id: to.id,
        to_account_name: to.name,
      },
    });
  }
}
